export default {
    home: {
        Entrar: 'Entre',
        Registro: 'Registro',
        Recharge: 'Recargar',
        Withdrawal: 'Retirar',
        exitText: 'Essa operação vai sair. Você quer continuar?',
        hint: 'pista',
        Sure: 'Claro',
        Cancel: 'Cancelar',
        exit_successfully: 'sair com sucesso',
        winners: 'vencedores',
        Account: 'Conta',
        Number: 'Número',
        Amount_of_money: 'Quantidade de dinheiro',
        Multiple: 'Multiple',
        Total_amount: 'Montante total',
        Confirm:'Confirmar'
    },
    activity: {
        Recharge: 'Recargar',
        Game: 'Jogo',
        Member: 'MemMembrober',
        Agent: 'Agente'
    },
    deposit: {
        Category: 'Categoria',
        Recharge_amount: 'Quantidade de recargamento',
        Time: 'Tempo',
        Recharge: 'Recargar',
        Withdrawal_amount: 'Quantidade de retirada',
        Game: 'Jogo',
        Betting_amount: 'Montante de apostas',
        Recharge_records: 'Recargar registros',
        Withdrawal_records: 'Registros de retirada',
        Betting_records: 'Registos de apostas',
        Withdrawal:'Retirar',
        Betting:'Apostar'
    },
    invite: {
        Bonus_recebido: 'Bonus de convite recebido',
        Numero_convite: 'Numero total de convite',
        Meu_convite: 'Meu link de convite',
        Receber: 'Receber',
        Membro: 'Membro',
        VIP: 'VIP',
        Number_Invitations: 'Número de Invitações',
        Recarga_total: 'Montante total de cobrança',
        Apostas_totales: 'Aposto total',
        Receitas_geradas: 'Receitas geradas',
        Category: 'Categoria',
        Recharge_amount: 'Quantidade de recargamento',
        Time: 'Tempo',
        Bonus: 'Bonus',
        Regra: 'Regra',
        Equipe: 'Equipa',
        Commission: 'Registro da Comissão'
    },
    letter: {
        Receive: 'Receber',
        Letter: 'Carta',
        Anuncio: 'anunciar',
    },
    my: {
        Balance_account: 'Conta de saldo',
        Withdrawable_account: 'Conta retirada',
        Commission_account: 'Conta da Comissão',
        Value_lock: 'Valor para bloquear',
        Current_level: 'Nivel atual',
        VIP_details: 'Detalles do VIP',
        Game_Record: 'Game Record'
    },
    setup: {
        Name: 'Nome:',
        Phone: 'Telefone:',
        Mail: 'Correio:',
        Security_code: 'Código de segurança:',
        Save: 'Guardar'
    },
    vip: {
        update_criteria: 'critérios de atualização',
        Total_deposit: 'Depósito total',
        Apostas_totales: 'Aposto total',
        Level_privileges: 'Descrição de nível membro',
        Withdrawal_equity: 'Retiração da equidade',
        Announce_rewards: 'Anunciar recompensas',
        Deposit: 'Depósito',
        Category: 'Categoria',
        Bonus_amount: 'Quantidade de bónus',
        Time: 'Tempo',
        VIP: 'VIP',
        Bonus_VIP: 'Bonus VIP',
        Introduction:'Introdução ao nível',
        before:'antes',
        after:'após',
    },
    login_register: {
        Login: 'Entrar',
        Register: 'Registar',
        Confirm: 'Confirme sua conta e senha antes de entrar',
        Forgot_password: 'Esqueci a senha',
        Verification_code: 'Código de verificação',
        tow_password:'duas senhas são inconsistentes'
    },
    Recharge: {
        Extractable_quantity: 'Quantidade extraitável',
        Enter_your_withdrawal_amount: 'Entre sua quantidade de retirada',
        Please_enter_your_amount: 'Por favor introduz sua quantidade',
        Phone_number: 'Número de telefone',
        Enter_phone_number: 'Introduz o número de telefone',
        Pix_Enter_your_amount: 'Pix Introduz sua quantidade',
        Chave_Pix: 'Chave Pix (CPF)',
        Retirar: 'Retirar',
    },
    Sidebar: {
        VIP_Bonus: 'VIP Bonus',
        Play_History: 'Jogar história',
        Download: 'Descargar',
        Mail: 'Correio',
        set_up: 'Configurar',
        Betting_record: 'Rexistro de apostas',
        Recharge: 'Recargar',
        Withdraw: 'Retirar',
    },
    withdraw: {
        Deposit: 'Depósito',
        Your_Balance: 'Seu equilíbrio',
        Choose_deposit_method: 'Escolha um método de depósito',
        PPDBET_Pix: 'PPDBET-Pix'
    }
}
